import React from 'react'
import classNames from 'classnames'

export default class Ad extends React.Component {
 
  render() {

    const {
      id,
      collapseBeforeLoad,
      refreshIfVisible,
      isOutOfPage,
      slotType = null,
      include = [],
      exclude = [],
      kvps = {},
      className = '',
      kvpos = '',
      inView = false
    } = this.props

    let slotKvps = []
    let adProps = { id: id, key: id }

    /* no type no ad */
    if(slotType === null) {
      return null
    }

    /* default if pos not specified */
    if(typeof kvps.pos === 'undefined') {
      kvps.pos = slotType
    }

    /* build key value pair string */
    for (let k in kvps) {
      if(k !== null && kvps.k !== null) {
        slotKvps.push(k + '=' + kvps[k])
      }
    }

    /* build up the div properties */
    adProps.className = classNames('react-ad', className, {
      'ad-slot' : !inView ? true : false
    })

    adProps['data-slot-type'] = slotType
    adProps['data-kvpos'] = kvpos

    if(isOutOfPage) {
      adProps['data-out-of-page'] = 'true'
    }

    if(refreshIfVisible) {
      adProps['data-refresh-if-visible'] = 'true'
    }

    if(collapseBeforeLoad) {
      adProps['data-collapse-before-load'] = 'true'
    }

    if(include.length > 0) {
      let includeStr = include.join(',')
      adProps['data-include-bp'] = includeStr
    }

    if(exclude.length > 0) {
      let excludeStr = exclude.join(',')
      adProps['data-exclude-bp'] = excludeStr
    }
    
    if(slotKvps.length > 0) {
      let kvpsStr = slotKvps.join(',')
      adProps['data-slot-kvps'] = kvpsStr
    }

    return (
        <div {...adProps} />
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/components/common/Ad.jsx
 **/